<template>
  <div class="home">
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    }
  }
</script>

<style>
  
</style>


// WEBPACK FOOTER //
// src/pages/shop/home/home.vue